import { atom } from "jotai";

export const MemoLikeAtom = atom<boolean>(false);
